import { Routes } from "@angular/router";
import { StaticPageComponent } from "./components/static-page/static-page.component";

export const routes: Routes = [
    {
        path: 'page/:pageId',
        component: StaticPageComponent
    },
]